import React from "react";
import HeaderContainer from "../Header/HeaderContainer";
import InfoCardComponent from "../../reusables/InfoCard/InfoCardComponent";

import { Col, Grid, Layout, Row, Space } from "antd";
import UserOptionsGroup from "components/reusables/UserOptionsGroup/UserOptionsGroup";
import { UserOptionsGroupTypes } from "components/reusables/UserOptionsGroup/UserOptionsGroup.types";
import BodyContentComponent from "components/reusables/BodyContent/BodyContentComponent";
import transferenceIcon from "assets/namespace/icons/tfrIcon";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import Icon from "@ant-design/icons";
import imgTrfExpress from "../../../assets/namespace/logos/autofact_transferencia_express.svg";
import MinimalFooterComponent from "components/reusables/MinimalFooter/MinimalFooterComponent";
import { useSelector } from "react-redux";
import { StorageInterface } from "store/StorageInterface";
const { useBreakpoint } = Grid;
// const [isActive, setIsActive] = useState(false);

const options: UserOptionsGroupTypes = {
  options: [
    {
      value: 1,
      text: "Quiero comprar un vehículo",
      selected: false,
      className: "",
      btnClassName: "",
      action: undefined,
      disabled: false,
    },
    {
      value: 2,
      text: "Quiero vender un vehículo",
      selected: false,
      className: "",
      btnClassName: "",
      action: undefined,
      disabled: false,
    },
    {
      value: 3,
      text: "Solo quiero conocer el proceso",
      selected: false,
      className: "",
      btnClassName: "",
      action: undefined,
      disabled: false,
    },
  ],
};

const TfrIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={transferenceIcon} {...props} />
);
const { Header, Sider, Content, Footer } = Layout;



function UserOptionsContainer() {
 
  const screens = useBreakpoint();

  const userData = useSelector((state: StorageInterface) => { return state.userDataSlice;});

  return (
      <Layout id="container">
        <Space id="body" direction="vertical" size={35}>
          <HeaderContainer />
          <Layout  style={{ padding: "1rem", paddingTop:'30px', alignItems: "center" }}>
            <Row justify="space-between" align="bottom" style={{margin: "auto", maxWidth:"1140px"}}>
              <Col xs={24} md={10} style={{maxWidth:"450px"}} >
                <Space size={24} direction="vertical">
                  <div>
                    <BodyContentComponent
                      icon={<TfrIcon style={{ fontSize: `${!screens["md"] ? '31.9px': '39.9px'}` }}></TfrIcon>}
                      bodyHeaderText="Te damos la bienvenida al simulador de Transferencia de vehículos"
                    ></BodyContentComponent>
                  </div>
                  <div>
                    <InfoCardComponent
                      text={`${userData.fullname ?  userData.fullname + ', ' : ' '}¿Qué te gustaría realizar próximamente?`}
                      type={"cardInfo"}
                      number={"2"}
                    ></InfoCardComponent>
                  </div>
                  <div style={{ display: "inline-grid", width: "100%" }}>
                    <UserOptionsGroup {...options} />
                  </div>
                </Space>
              </Col>
              <Col xs={0} md={12} style={{paddingLeft:'80px'}}>
                <div>
                  <img
                    src={imgTrfExpress}
                    alt="Transferencia Online, Autofact"
                    style={{width:'100%'}}
                  />
                </div>
              </Col>
            </Row>
          </Layout>
        </Space>
        <div id="footer">
          <MinimalFooterComponent/>
        </div>
      </Layout>
  );
}

export default UserOptionsContainer;
